module.exports = __webpack_public_path__ + "img/innovator-enthusiast-2.a5082f50.svg";